var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-tab"},[(!_vm.hasTabSlot)?_c('nav-tabs',{attrs:{"tabs":_vm.tabs},on:{"onTabClick":_vm.onTabClick}}):_vm._e(),_vm._t("tab"),_c('div',{staticClass:"tab-content"},[(!_vm.hasTabContent)?_vm._t("default"):_vm._e(),_vm._t("content")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf7ad10c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/mdTab/index.vue
// module id = QYmu
// module chunks = 12